import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  axiosInstance,
  clearAuthTokenData,
  clearUsername,
  LOGIN,
  setAuthData,
  setUsername,
} from '@/core';
import { AUTH_ROUTE } from '@/routes';

type LoginData = {
  user: {
    username: string;
  };
  token_data: {
    token: string;
    expires: number;
  };
};

export const useLogin = ({
  onSuccess,
  onError,
}: { onSuccess?: () => void; onError?: () => void } = {}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const login = async (username: string, password: string) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `${AUTH_ROUTE}/${LOGIN}`,
        { username, password },
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            accept: 'application/json',
          },
          withCredentials: true,
        },
      );
      const responseData: LoginData = response.data;
      if (response.status === 200 && responseData) {
        setAuthData(responseData.token_data.token, responseData.token_data.expires);
        setUsername(username);
        onSuccess?.();
      } else {
        setError(true);
        setLoading(false);
        onError?.();
      }
    } catch {
      setError(true);
      setLoading(false);
      onError?.();
    }
  };

  const logout = async () => {
    clearAuthTokenData();
    clearUsername();
    navigate(AUTH_ROUTE);
  };

  return { error, setError, loading, login, logout };
};
